
export default {
  methods: {
    samePassword(p1, p2) {
      if (p1 !== p2) {
        return new Error('入力されたパスワードが一致しません。')
      }
      return null
    },
    validPassword(p) {
      if (/[^a-zA-Z0-9]+/g.test(p)) {
        return new Error('使用できない文字が入っています。')
      }
      if (p.length < 8 || 127 < p.length) {
        return new Error('パスワードは8文字以上127文字以下で入力してください。')
      }
      if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/g.test(p)) {
        return new Error('パスワードは大小英文字と数字の両方を含んでください。')
      }
      return null
    },
    validNickname(n) {
      if (n.length > 10) {
        return new Error('ニックネームは10文字以下で入力してください。')
      }
      return null
    },
    validBirthDate(year, month) {
      const none = '未選択'
      if (year === none || month === none) {
        return new Error('「年」と「月」両方を設定してください。')
      }
      return null
    },
    validMailAddress(mailAddress) {
      if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(mailAddress)) {
        return null
      }
      return new Error("正しいメールアドレスを入力してください。")
    }
  }
}
